//
// # Exhaust
//
// Compile-time "exhaustiveness" and/or "unreachability" check.
// For use in patterns like:
//
// ```
// switch (direction) {
//  case Dir.Horiz: ...
//  case Dir.Vert: ...
//  default: exhaust(direction);
// }
// ```
//
export function exhaust(_: never): never {
  throw new Error(); // Note if used as intended, the body of this function is unreachable.
}
